jQuery(document).ready(function($)
{


    /** UPDATED ANNUALLY */    
    var current_div_m = 446505;
    var current_div_f = 446503;
    var current_rema_m = 446213;
    var current_rema_f = 446211;
    var current_season = 2627;

    var current_season_start = 1782864000; // 1 july 2026 SEASON CHANGE!
    var current_season_end = 1814313600; // 30 june 2027 SEASON CHANGE! 

    //const current_season_start = 1719828000; // 1 july 2025 SEASON CHANGE!
    //const current_season_end = 1751277600; // 30 june 2026 SEASON CHANGE!

var Ajax =
    {
        token: '',
        url: '/wp-content/themes/nth-5.3/resources/ajax.php',
        execute: function (payload, success, failure)
        {
            var contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
            var processData = true;
            var cache = true;
            var async = payload.async === false ? false : true;


            ////console.log (payload);

            if (payload.data instanceof FormData) {
                // set config values
                processData = false;
                cache = false;
                contentType = false;

                payload.data.append('class', payload.class);
                payload.data.append('method', payload.method);
                // Can only store string-data so JSON-ify params
                payload.data.append('json', JSON.stringify(payload.param));

                // set data proper
                payload = payload.data;
            } else
                payload.token = Ajax.token;


            $.ajax({
                type: 'POST',
                url: Ajax.url,
                contentType: contentType,
                processData: processData,
                cache: cache,
                data: payload,
                async: async,
                success: function (data) {
                ////console.log (data);
                    if (data.result === 'success')
                    {
                        if (success instanceof Function)
                            success(data);
                    } else {
                        if (failure instanceof Function)
                            failure(data);
                    }
                },
                error: function (jqXHR, status) {
                    console.log('failure: ' + status);
                },
            });
        },
    };

    window.Ajax = Ajax;

    window.Ajax.getTeamData = function ( sTheJson, success, failure )
    {
        window.Ajax.execute ({ class: 'generate', method: 'admin_get_team_data', param: sTheJson }, success, failure );
    }

    window.Ajax.getTaxonomyData = function ( sTheJson, success, failure )
    {
        window.Ajax.execute ({ class: 'generate', method: 'admin_get_taxonomy_data', param: sTheJson }, success, failure );
    }

    window.Ajax.getMatchTitleID = function ( sTheJson, success, failure )
    {
        window.Ajax.execute ({ class: 'generate', method: 'admin_get_match_title_id', param: sTheJson }, success, failure );
    }

    window.Ajax.getPlayerID = function ( sTheJson, success, failure )
    {
        window.Ajax.execute ({ class: 'generate', method: 'admin_get_player_id', param: sTheJson }, success, failure );
    }

    window.Ajax.getRelatedPlayers = function ( sTheJson, success, failure )
    {
        window.Ajax.execute ({ class: 'generate', method: 'admin_get_related_players', param: sTheJson }, success, failure );
    }

    window.Ajax.getPlayerData = function ( sTheJson, success, failure )
    {
        window.Ajax.execute ({ class: 'generate', method: 'admin_get_player_data', param: sTheJson }, success, failure );
    }

    window.Ajax.getPostData = function ( sTheJson, success, failure )
    {
        window.Ajax.execute ({ class: 'generate', method: 'admin_get_post_data', param: sTheJson }, success, failure );
    }

    window.Ajax.getAdminOptions = function ( sTheJson, success, failure )
    {
        window.Ajax.execute ({ class: 'generate', method: 'admin_get_admin_options', param: sTheJson }, success, failure );
    }


    function get_the_teamdata()
    {
        window.Ajax.getTeamData (
        {
        },
        function (data)
        {
            return (data.teamdata);
        },
        function ()
        {
            return (0);
        });

    }

    window.get_the_teamdata = get_the_teamdata;

    /* eslint-disable */
    if ( typeof acf !== 'undefined' )
    {
        /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        posts: players, update based on team id
        - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */

        var postId = my_acf_data.post_id;

        if (!postId)
        { 
            sThePageName = getUrlParameter('page');
        }

        window.Ajax.getPostData (
        {
            id: 'admin-options',
            context: 'admin'
        },
        function (data)
        {
            window.admin_options = data.teamdata;

            let aTheTeams = [];

            aTheTeams.push({ team_id: data.teamdata.team_id, team_name: data.teamdata.team_name, tournament_id: data.teamdata.primary_tournament_id });

            if (data.teamdata.extra_ids != undefined && data.teamdata.extra_ids.length > 0) 
            {
                $.each (data.teamdata.extra_ids, function (index, value){
                    aTheTeams.push({ team_id: value.team_id, team_name: value.team_name, tournament_id: value.tournament_id });
                });
            }

            window.admin_teams = aTheTeams;

            console.log (window.admin_options);
            console.log (window.admin_teams);
        });

        var setPlayers = function( field )
        {
            var select = field.$el.find('select');
            
            if (select)
            {
                var iTheTeamID = 0;
                var playerID;

                window.Ajax.getPlayerID (
                {
                    id: getUrlParameter ('post'), 
                    context: 'admin'

                },
                function (playerdata)
                {
                    //playerID =
                    console.log (playerdata);

                    if (playerdata.playerdata.player_id > 0)
                    {
                        playerID = playerdata.playerdata.player_id;
                    }
                    else
                    {
                        $('[data-name=player_name]').find('input').val('').prop('disabled', 'disabled');
                    }

                   // alert (playerID);


                    window.Ajax.getTeamData (
                    {
                        context : 'admin'
                    },
                    function (data)
                    {
                        var aTheTeamData = data.teamdata;

                        iTheTeamID = aTheTeamData.team_id;

                        if (iTheTeamID)
                        {
                            select.empty();

                            var temp = '<option>Velg spiller</option>';
                            select.append(temp);

                            var storedValue = field.val(); // ACF API method to get the stored value

                            $.ajax({
                                url: 'https://prime.webcore.no/teams/' + iTheTeamID + '/players?usenif&size=500', // acf stored value
                                type: 'get',
                                success: function(data)
                                {
                                    if (!data)
                                    {
                                        return;
                                    }
                                    for(i=0; i< data.length; i++)
                                    {
                                        var item = '<option value="'+data[i]['id']+'">'+data[i]['name']+'</option>';

                                        if (data[i]['id'] == playerID)
                                        {
                                            item = '<option selected value="'+data[i]['id']+'">'+data[i]['name']+'</option>';

                                            $('[data-name=player_name]').find('input').val(data[i]['name']);
                                        }

                                        select.append(item);
                                    }
                                }
                            });
                        }
                    },
                    function ()
                    {
                        return (0);
                    });
                },
                function (data)
                {

                });
            }
        };
        /* eslint-disable */
        acf.addAction('append_field/name=prime_player_id', setPlayers);
        acf.addAction('load_field/name=prime_player_id', setPlayers);



         var setRelatedPlayers = function( field )
        {
            var select = field.$el.find('select');
            
            if (select)
            {
                var iTheTeamID = 0;
                var playerID;

                window.Ajax.getRelatedPlayers (
                {
                    id: getUrlParameter ('post'), 
                    context: 'admin'
                },
                function (playerdata)
                {
                    //playerID =
                    console.log ('--------------');
                    console.log (playerdata);

                    window.Ajax.getTeamData (
                    {
                        context : 'admin'
                    },
                    function (data)
                    {
                        var aTheTeamData = data.teamdata;

                        iTheTeamID = aTheTeamData.team_id;

                        if (iTheTeamID)
                        {
                            select.empty();


                            $.ajax({
                                url: 'https://prime.webcore.no/teams/' + iTheTeamID + '/players?usenif&size=500', // acf stored value
                                type: 'get',
                                success: function(data)
                                {
                                    if (!data)
                                    {
                                        return;
                                    }
                                    for(i=0; i< data.length; i++)
                                    {
                                        var item = '<option value="'+data[i]['id']+'">'+data[i]['name']+'</option>';

                                        
                                        for (let j = 0; j < playerdata.playerdata.length; j++) 
                                        {
                                            console.log(playerdata.playerdata[j]);
                                            console.log(data[i]['id']);
                                            console.log(playerdata.playerdata[j] == data[i]['id']);
                                            console.log('$$$$$');
                                            if(playerdata.playerdata[j] == data[i]['id'])
                                            {
                                               item = '<option value="'+data[i]['id']+'" selected>'+data[i]['name']+'</option>';
                                            }

                                        }
                                        select.append(item);
                                    }
                                }
                            });
                        }
                    },
                    function ()
                    {
                        return (0);
                    });
                },
                function (data)
                {

                });
            }
        };
        /* eslint-disable */
        acf.addAction('append_field/name=prime_player_ids', setRelatedPlayers);
        acf.addAction('load_field/name=prime_player_ids', setRelatedPlayers);

         var setContactPersons = function( field )
        {
            var select = field.$el.find('select');
            if (select)
            {
                var iTheTeamID = $(select).closest('.acf-fields').find('[data-name=team_id]').find('input').val();
                
                //alert (iTheTeamID);
                var playerID;

                window.Ajax.getAdminOptions (
                {
                    context: 'admin'
                },
                function (postdata)
                {
                    //playerID =
                    //console.log (postdata);

                    if ($(select).closest('[data-name=extra_ids]').length > 0)
                    {
                        playerID = postdata.options.extra_ids[0].spokesperson_player_id;
                    }
                    else
                    {
                        playerID = postdata.options.spokesperson_player_id;
                    }

                    select.empty();

                    var temp = '<option>Velg spiller eller støtteapparat</option>';
                    select.append(temp);

                    var storedValue = field.val(); // ACF API method to get the stored value

                    $.ajax({
                        url: 'https://prime.webcore.no/teams/' + iTheTeamID + '/players?usenif&size=500', // acf stored value
                        type: 'get',
                        success: function(data)
                        {
                            if (!data)
                            {
                                return;
                            }
                            //for(i=0; i< data.length; i++)
                            //{


                                // Create two optgroups: one for category 1 or 2, one for the rest
                                let optgroupMain = $('<optgroup label="Spillere"></optgroup>');
                                let optgroupOther = $('<optgroup label="Støtteapparat"></optgroup>');

                                for (let i = 0; i < data.length; i++) {
                                    let option = $('<option></option>')
                                        .attr('value', data[i]['id'])
                                        .text(data[i]['name']);

                                    if(playerID && data[i]['id'] == playerID)
                                    {
                                        option.prop('selected', 'selected');
                                    }    
                                    if (data[i]['category'] === 1) {
                                        optgroupMain.append(option);
                                    } else if (data[i]['category'] === 2){
                                        optgroupOther.append(option);
                                    }
                                }
                                select.append(optgroupMain);
                                select.append(optgroupOther);

                                /*var item = '<option value="'+data[i]['id']+'">'+data[i]['name']+'</option>';

                                if (data[i]['id'] == playerID)
                                {
                                    item = '<option selected value="'+data[i]['id']+'">'+data[i]['name']+'</option>';
                                }

                                select.append(item);*/
                            //}
                        }
                    });
                   
                },
                function (data)
                {

                });
            }
        };
        /* eslint-disable */
        acf.addAction('append_field/name=spokesperson_player_id', setContactPersons);
        acf.addAction('load_field/name=spokesperson_player_id', setContactPersons);

        $(document).on('change', '[data-name=spokesperson_player_id] select', function(e)
        {
            //console.log ('change detected');
            var iTheSelectedPlayerID =  $(e.target).find('option:selected').val();

            var wrapper = $(e.target).closest('.acf-fields');

            if (iTheSelectedPlayerID)
            {
                window.Ajax.getPlayerData (
                {
                    id: iTheSelectedPlayerID,
                    context: 'admin'
                },
                function (data)
                {
                    //console.log (data.playerdata);

                    $(wrapper).find('[data-name=spokesperson_name]').find('input').val(data.playerdata.name);
                    $(wrapper).find('[data-name=spokesperson_role]').find('input').val(data.playerdata.position);
                    $(wrapper).find('[data-name=spokesperson_player_id]').find('input').val(data.playerdata.id);
                    $(wrapper).find('[data-name=spokesperson_image_url]').find('input').val(data.playerdata.image_hires);
                    //$('[data-name=player_name]').find('input').val(data.playerdata.player_name);
                },
                function (data)
                {K

                });
            }
        });

        function getPrimeMatches(iTheTeamID = 0, select = null )
        {

        var url = 'https://prime.webcore.no/teams/' + iTheTeamID + '/matches/?size=1000&from=' + current_season_start + '&to=' + current_season_end + '&sort=asc&usenif&nocache';
            //console.log ('getPrimeMatches called with teamID: ' + iTheTeamID);

            //console.log ('Fetching matches from URL: ' + url);
            $.ajax({
                url: url, // acf stored value
                type: 'get',
                success: function(data)
                {
                    if (!data)
                    {
                        return;
                    }

                    window.selectData = data;

                    
              //      console.log (data);

                    if (!$('body').hasClass('post-type-matchdata'))
                    {    
                        var temp = '<option>Velg kamp!</option>';
                        select.append(temp);
                    }

                    for(i=0; i< data.length; i++)
                    {
                        console.log (data[i]);
                        

                        // Extract date part and format as "dd. monthastext yyyy"
                        const dateStr = data[i]['when']['text'].split(' ')[0]; // "2026-03-08"
                        const [year, month, day] = dateStr.split('-');
                        const months = [
                            'jan', 'feb', 'mar', 'apr', 'mai', 'jun',
                            'jul', 'aug', 'sept', 'okt', 'nov', 'des'
                        ];
                        const formattedDate = `${parseInt(day, 10)}. ${months[parseInt(month, 10) - 1]} ${year}`;
                        //console.log(formattedDate);
                        let gender = '';
                        if (data[i]['tournament']['sex'] === 'M')   
                        {
                            gender = 'menn';
                        }
                        else
                        {
                            gender = 'kvinner';
                        }

                        var item = '<option value="'+data[i]['id']
                            +   '" data-tournament-id="'+data[i]['tournament']['id']
                            +   '" data-home-team-id="'+data[i]['home']['id']
                            +   '" data-away-team-id="'+data[i]['away']['id']
                            +   '">'+ data[i]['home']['name']['short'] 
                            +   '-' + data[i]['away']['name']['short'] 
                            +   '(' + data[i]['tournament']['name'] 
                            +   ' ' + gender + ')'
                            +   '(' + formattedDate 
                        + ')</option>';
                        select.append(item);
                    }

                    let aTemp = $(select).attr('id').split('-row-');

                    if (aTemp[1])
                    {
                        //console.log ('1');
                        aTemp = aTemp[1].split('-field_');
                        let iTheItemCount = aTemp[0];
                        window.ajax_get_match_title_id( $('#' + $(select).attr('id') ), iTheItemCount);
                        
                    }
                    else
                    {
                        //alert ('2');
                        window.Ajax.getPostData (
                        {
                            id: getUrlParameter ('post'),
                            context: 'admin'
                        },
                        function (data)
                        {
                            
                            $(select).find('option').each ( function (ii)
                            {


                                if ($(this).val() == data.teamdata.match_selector )
                                {
                                    var $form = $('#post');

                                    // Set the value without firing WP change detection
                                    $(select).val(data.teamdata.match_selector);

                                    if (typeof window.wp !== 'undefined' && wp.autosave) {
                                        // Mark the post as "not dirty"
                                        wp.autosave.server.postChanged = false;
                                        wp.autosave.server.initialCompareString = $form.serialize();
                                    }

                                    // Also reset the local jQuery serialized snapshot
                                    $form.data('serialized', $form.serialize());

                                    get_teams_from_prime($(select));
                                    window.kaia_article_id = $(select).find('option:selected').val();

                                    if (window.selectData[ii].home.id == window.teamdata.team_id)
                                    {
                                        window.kaia_article_team = 'home';
                                    }
                                    else
                                    {
                                        window.kaia_article_team = 'away';
                                    }
                                }
                            });
                        },
                        function ()
                        {
                            return (false);
                        });
                    }
                }
            });
        }

        var initMatches = function( field )
        {
            if ($(field.$el).closest('.acf-fields').find('[data-name=featured_player_home]').length > 0 
                && $(field.$el).closest('.acf-fields').find('[data-name=featured_player_away]').length > 0 
                && $(field.$el).closest('.acf-fields').find('[data-name=featured_players_home]').length > 0 
                && $(field.$el).closest('.acf-fields').find('[data-name=featured_players_away]').length > 0 
                && $(field.$el).closest('.acf-fields').find('[data-name=excluded_players_home]').length > 0 
                && $(field.$el).closest('.acf-fields').find('[data-name=excluded_players_away]').length > 0 
                && $(field.$el).closest('.acf-fields').find('[data-name=quoted_player_home]').length > 0 
                && $(field.$el).closest('.acf-fields').find('[data-name=quoted_player_away]').length > 0 
            )
            {
                $(field.$el).closest('.acf-fields').find('[data-name=featured_player_home]').find('select').empty();
                $(field.$el).closest('.acf-fields').find('[data-name=featured_player_away]').find('select').empty();
                $(field.$el).closest('.acf-fields').find('[data-name=featured_playes_home]').find('select').empty();
                $(field.$el).closest('.acf-fields').find('[data-name=featured_players_away]').find('select').empty();
                $(field.$el).closest('.acf-fields').find('[data-name=excluded_players_home]').find('select').empty();
                $(field.$el).closest('.acf-fields').find('[data-name=excluded_players_away]').find('select').empty();
                $(field.$el).closest('.acf-fields').find('[data-name=quoted_player_home]').find('select').empty();
                $(field.$el).closest('.acf-fields').find('[data-name=quoted_player_away]').find('select').empty();
            }

            var select = field.$el.find('select');

            if (select)
            {
                var iTheTeamID = 0;
                window.Ajax.getTeamData (
                {
                    context: 'admin'
                },
                function (data)
                {
                    var aTheTeamData = data.teamdata;
                    window.teamdata = aTheTeamData;

                    //console.log (aTheTeamData.teams);

                    iTheTeamID = aTheTeamData.team_id;

                    select.empty();
                    //var temp = '<option>Velg kamp</option>';
                    //select.append(temp);

                    getPrimeMatches(iTheTeamID, select);
                    
                    if (iTheTeamID && (aTheTeamData.extra_teams != undefined && aTheTeamData.extra_teams.length > 0))
                    {
                        ////console.log ('extra teams');
                        $.each (aTheTeamData.extra_teams, function (index, value)
                        {
                            getPrimeMatches(value.team_id, select);
                        });
                    }
                    {

                    }
                },
                function ()
                {
                    return (0);
                });
            }
        };
        /* eslint-disable */
        acf.addAction('append_field/name=match_selector', initMatches);
        acf.addAction('load_field/name=match_selector', initMatches);
        acf.addAction('prepare_field/name=match_selector', initMatches);


        function ajax_get_match_title_id(select, count)
        {
            //alert ('bar');
            window.Ajax.getPostData (
            {
                id: postId,
                context: 'admin'
            },
            function (data)
            {
               
                
                $(select).find('option').each ( function ()
                {
                    if ($(this).val() == data.teamdata.match_title_overrider[count].match_selector )
                    {
                        $(this).prop('selected', 'selected');
                    }
                });

                if ( $(select).find('option:selected').length > 0 )
                {
                    get_teams_from_prime($(select));
                }

            },
            function ()
            {
                return (false);
            });
        }

        window.ajax_get_match_title_id = ajax_get_match_title_id;


        $(document).on('change', '[data-name=select_admin_team] select', function(e)
        {
            //console.log ('change detected');

            var iTheSelectedTeamID =  $(e.target).find('option:selected').val();


            window.Ajax.getTeamData (
            {
                context: 'admin'
            },
            function (data)
            {
                var aTheTeamData = data.teamdata;
                //console.log (aTheTeamData);

                if (iTheSelectedTeamID == aTheTeamData.team_id)
                {
                    $('.acf-field[data-name=team_id]').find('input').val(aTheTeamData.team_id);
                    $('.acf-field[data-name=tournament_id]').find('input').val(aTheTeamData.tournament_id);
                }
                else
                {
                    $.each (aTheTeamData.extra_teams, function (index, value)
                    {
                        //console.log (index);
                        //console.log (value);
                        if (iTheSelectedTeamID == value.team_id)
                        {
                            $('.acf-field[data-name=team_id]').find('input').val(value.team_id);
                            $('.acf-field[data-name=tournament_id]').find('input').val(value.tournament_id);
                        }
                    });
                }



                
            },
            function ()
            {
                return (0);
            });
            //get_teams_from_prime($(e.target));
        });



        $(document).on('change', '[data-name=match_selector] select', function(e)
        {
            //console.log ('change detected');
            get_teams_from_prime($(e.target));
            //$('.generate-article').prop('disabled', false).removeProp('disabled');
            window.kaia_article_id = $(e.target).find('option:selected').val();

        
            /*if ($('input[name="post_title"]').val().trim() === '') {
                var selectedText = $(e.target).find('option:selected').text();
                $('#title-prompt-text').addClass('screen-reader-text');
                $('input[name="post_title"]').val(selectedText);
                $('.select2-selection__rendered').find('.acf-selection').text(selectedText);
                $('.select2-selection__rendered').attr('title', selectedText); */
            //}
        });


        window.kaia_article_type = '';

        $(document).on('change', 'select#match-system-function-select', function(e)
        {
            //console.log ('change detected');

            if ($(e.target).find('option:selected').val() === 'preview') 
            {
                window.kaia_article_type = 'preview';
                $('.generate-article').prop('disabled', false).removeProp('disabled');

                // Handle the case for generating preview
            } else if ($(e.target).find('option:selected').val() === 'report') {
                // Handle the case for generating report
                $('.generate-article').prop('disabled', false).removeProp('disabled');
                window.kaia_article_type = 'report';
            }
            else
            {
                $('.generate-article').prop('disabled', true).attr('disabled', 'disabled');
                return;
            }

        });


        

        function get_teams_from_prime($this)
        {

            ////console.log ();
            if ($($this).closest('.acf-fields').find('[data-name=home_id]').length > 0 && $($this).closest('.acf-fields').find('[data-name=away_id]').length > 0 ) 
            {
                //console.log ('init detected 2');
                //console.log ($this.find('option:selected').val());

                let iTheMatchID = $this.find('option:selected').val();
                //console.log ('https://prime.webcore.no/matches/' + iTheMatchID + '?usenif&nocache');

                $.ajax({
                    url: 'https://prime.webcore.no/matches/' + iTheMatchID + '?usenif&nocache', // acf stored value
                    type: 'get',
                    success: function(data)
                    {
                        if (!data || !data.home || !data.away)
                        {
                            return;
                        }

                        $($this).closest('.acf-fields').find('[data-name=home_id]').find('input').val(data.home.id);
                        $($this).closest('.acf-fields').find('[data-name=away_id]').find('input').val(data.away.id);

                        //console.log (data.home.id);
                        //console.log (data.away.id);
                    }
                });

            }
            else if ($this.closest('.acf-fields').find('[data-name=featured_player_home]').length > 0 
                && $this.closest('.acf-fields').find('[data-name=featured_player_away]').length > 0 
                && $this.closest('.acf-fields').find('[data-name=featured_players_home]').length > 0 
                && $this.closest('.acf-fields').find('[data-name=featured_players_away]').length > 0 
                && $this.closest('.acf-fields').find('[data-name=excluded_players_home]').length > 0 
                && $this.closest('.acf-fields').find('[data-name=excluded_players_away]').length > 0 
                && $this.closest('.acf-fields').find('[data-name=quoted_player_home]').length > 0
                && $this.closest('.acf-fields').find('[data-name=quoted_player_away]').length > 0
            )
            {
                //alert ('init detected 1');
                //console.log ($this.find('option:selected').val());

                
                let iTheMatchID = $this.find('option:selected').val();
                //console.log ('https://prime.webcore.no/matches/' + iTheMatchID + '?usenif&nocache');

                $.ajax({
                    url: 'https://prime.webcore.no/matches/' + iTheMatchID + '?usenif&nocache', // acf stored value
                    type: 'get',
                    success: function(data)
                    {
                        if (!data)
                        {
                            return;
                        }

                        //console.log (data.home.score);
                        /*if (data.home.score == 0 && data.away.score == 0)
                        {
                            $('.acf-field-686ba0a2cdff1').find('option[value="preview"]').prop('selected', 'selected');
                            $('.acf-field-686ba0a2cdff1').find('select').prop('disabled', 'disabled');
                            $('#match-system-function-box').find('p.info').text('Generér forhåndsomtale av kampen.');
                        }
                        else
                        {
                            $('.acf-field-686ba0a2cdff1').find('option[value="report"]').prop('selected', 'selected');
                            $('.acf-field-686ba0a2cdff1').find('select').prop('disabled', 'disabled');
                            $('#match-system-function-box').find('p.info').text('Generér kamprapport fra kampen.');
                        }*/

                        //console.log ('https://prime.webcore.no/teams/' + data.home.id + '/players?usenif&size=500&nocache');

                        window.current_home_team_id = data.home.id;
                        window.current_away_team_id = data.away.id;

                        $.ajax({
                            url: 'https://prime.webcore.no/teams/' + data.home.id + '/players?usenif&size=500&nocache', // acf stored value
                            type: 'get',
                            success: function(data)
                            {
                                if (!data)
                                {
                                    return;
                                }

                                setFeaturedPlayer('[data-name=featured_player_home]', data, 'featured_player_home', $this.closest('.acf-fields'));
                                setFeaturedPlayer('[data-name=featured_players_home]', data, 'featured_players_home', $this.closest('.acf-fields'));
                                setFeaturedPlayer('[data-name=excluded_players_home]', data, 'excluded_players_home', $this.closest('.acf-fields'));
                                setFeaturedPlayer('[data-name=quoted_player_home]', data, 'quoted_player_home', $this.closest('.acf-fields'));      
                            }
                        });

                        //console.log ('https://prime.webcore.no/teams/' + data.away.id + '/players?usenif&size=500&nocache');

                        $.ajax({
                            url: 'https://prime.webcore.no/teams/' + data.away.id + '/players?usenif&size=500&nocache', // acf stored value
                            type: 'get',
                            success: function(data)
                            {
                                if (!data)
                                {
                                    return;
                                }

                                setFeaturedPlayer('[data-name=featured_player_away]', data, 'featured_player_away', $this.closest('.acf-fields'));
                                setFeaturedPlayer('[data-name=featured_players_away]', data, 'featured_players_away', $this.closest('.acf-fields'));
                                setFeaturedPlayer('[data-name=excluded_players_away]', data, 'excluded_players_away', $this.closest('.acf-fields'));
                                setFeaturedPlayer('[data-name=quoted_player_away]', data, 'quoted_player_away', $this.closest('.acf-fields'));
                            }
                        });
                    }
                });
            }
        }

        function setFeaturedPlayer(selector, data, prop, parent)
        {

            //console.log (prop);

            let select = $(parent).find(selector).find('select');

            if (prop == 'featured_players_home' || prop == 'featured_players_away' || prop == 'excluded_players_home' || prop == 'excluded_players_away')
            {
                select.attr('multiple', 'multiple');
            }


            $(select).html('');

            $(select).append('<option value="0">Velg!</option>');

            if (prop === 'quoted_player_home' || prop === 'quoted_player_away') {
                // Create two optgroups: one for category 1 or 2, one for the rest
                let optgroupMain = $('<optgroup label="Spillere"></optgroup>');
                let optgroupOther = $('<optgroup label="Støtteapparat"></optgroup>');

                for (let i = 0; i < data.length; i++) {

                    //console.log ('data');
                    //console.log(data[i]);
                    //console.log('-----------------------------');

                    if (data[i]['active'] == true) {

                        let option = $('<option></option>')
                            .attr('value', data[i]['id'])
                            .text(data[i]['name']);
                        if (data[i]['category'] === 1) {
                            optgroupMain.append(option);
                        } else if (data[i]['category'] === 2){
                            optgroupOther.append(option);
                        }
                    }
                }
                select.append(optgroupMain);
                select.append(optgroupOther);
              
            }
            else
            {
               for(i=0; i< data.length; i++)
                {
                    if (data[i]['category'] == 1 && data[i]['active'] == true)
                    {

                        //console.log ('data');
                        //console.log(data[i]);
                        //console.log('-----------------------------');

                        let item = '<option value="'+data[i]['id']+'">'+data[i]['name']+'</option>';
                        select.append(item);
                    }
                }
            }

            window.Ajax.getPostData (
            {
                id: postId,
                context: 'admin'
            },
            function (data)
            {

                //console.log ('fu');
                //return false;
                if (prop == 'featured_players_home' || prop == 'featured_players_away' || prop == 'excluded_players_home' || prop == 'excluded_players_away')
                {
                    let selectedValues = data.teamdata[prop];
                    if (Array.isArray(selectedValues)) 
                    {
                        $(select).val(selectedValues).trigger('change');
                        //$('#post').data('serialized', $('#post').serialize());
                    } 
                    else 
                    {
                        $(select).val([selectedValues]).trigger('change');
                        //$('#post').data('serialized', $('#post').serialize());                   
                    }
                }
                else
                {   
                    //console.log('her????????');

                    $(select).find('option').each ( function ()
                    {
                        if ( $(this).val() == data.teamdata[prop] )
                        {
                            $(this).prop('selected', true);

                            //console.log('her 1');

                            if ( $(this).closest('.acf-field-select').attr('data-name') == 'quoted_player_home' || $(this).closest('.acf-field-select').attr('data-name') == 'quoted_player_away' )
                            {

                               

                                if ($(this).closest('.acf-field-select').attr('data-name') == 'quoted_player_home')
                                {

                                    console.log('her 2');
                                    console.log (data.teamdata[prop]);

                                    

                                    $('#acf-field_689da03091eed').val(data.teamdata[prop]);
                                }
                                else if ($(this).closest('.acf-field-select').attr('data-name') == 'quoted_player_away')
                                {
                                    $('#acf-acf-field_689da00091eec').val(data.teamdata[prop]);
                                }
                            }
                        }
                        else if ( $(this).val() == data.teamdata[prop + '_id'] )
                        {
                            $(this).prop('selected', true);

                            

                            if ( $(this).closest('.acf-field-select').attr('data-name') == 'quoted_player_home' || $(this).closest('.acf-field-select').attr('data-name') == 'quoted_player_away' )
                            {
                                $(this).closest('.acf-field-select').next().find('input').val(data.teamdata[prop + '_id']);
                            }
                        }
                    });


                    /*
                    if ( $(select).find('option').attr('value', data.teamdata[prop]).length > 0 )
                    {
                        //$(select).val(data.teamdata[prop]).trigger('change');
                        //$('#post').data('serialized', $('#post').serialize());
                    } 
                    else if ( $(select).find('option').attr('value', data.teamdata[prop + '_id']).length > 0 )
                    {
                        //$(select).val([data.teamdata[prop + '_id']]).trigger('change');
                        //$('#post').data('serialized', $('#post').serialize());                   
                    }
                        */

                }

                //var temp = '<option value="0">Velg!</option>';
                //select.prepend(temp);

            },
            function ()
            {
                return (false);
            });
           
        }

        //https://prime.webcore.no/teams/746278/players?usenif&size=50

        /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

        categories: teams, tournaments, based on season

        - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */

        var iTheSeason = 0;
        var iTheTournament = 0;

        $(document).on('change', '[data-name=nth_season] select', function()
        {
            setTournamentSelectBySeason ( $('[data-name=nth_tournament_id] select'), $(this).find ('option:selected').val() );
        });


        $(document).on('change', '[data-name=nth_tournament_id] select', function()
        {
            setTeamSelectByTournament ( $($('[data-name=nth_team_id] select')), $(this).find ('option:selected').val() );
        });

        /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        TOURNAMENT
        - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */

        var setTournaments = function( field )
        {
            var select = field.$el.find('select');

            if (select && $('[data-name=nth_season]').length > 0)
            {
                iTheSeason = $('[data-name=nth_season] select option:selected').val();

                if (iTheSeason)
                {
                    window.iTheTournamentID = 0;

                    if (window.getUrlParameter('tag_ID'))
                    {
                        window.Ajax.getTaxonomyData (
                        {
                            id: window.getUrlParameter('tag_ID'),
                            tax: window.getUrlParameter('taxonomy'),
                            context: 'admin'
                        },
                        function (data)
                        {
                            window.iTheTournamentID = data.taxonomydata.nth_tournament_id;
                            setTournamentSelectBySeason ( select, iTheSeason);
                        },
                        function ()
                        {
                            alert ('Det oppsto en feil');
                            window.iTheTournamentID = 0;
                        });
                    }
                }
            }
            else if (select)
            {
                window.Ajax.getPostData (
                {
                    id: 'admin-options',
                    context: 'admin'
                },
                function (data)
                {
                    select.empty();

                    var selected_tournaments = data.teamdata.frontpage_news_selector;

                    //console.log (selected_tournaments);

                    var temp = '<option>Velg turnering</option>';
                    select.append(temp);
                    $.ajax({
                        url: 'https://prime.webcore.no/tournaments/?usenif&nocache&&season=' + current_season + '&size=1000', // acf stored value
                        type: 'get',
                        success: function(data)
                        {
                            if (!data)
                            {
                                return;
                            }

                            //console.log (data);

                            for (i=0; i< data.length; i++)
                            {  
                                
                                var item;
                                if (data[i]['team_ids'].length > 0 && (data[i]['grouping'] == 'gl' || data[i]['grouping'] == '1d' || data[i]['grouping'] == 'nm' || data[i]['grouping'] == 'ecup'))
                                {

                                    var sex = 'kvinner';

                                    if (data[i]['sex'] == "M")
                                    {
                                        sex = 'menn';
                                    }
                                    item = '<option class="tournament-option" value="'+data[i]['id']+'">'+data[i]['name'] + ' (' + sex + ')</option>';

                                    if (selected_tournaments)
                                    {

                                        for (var j=0; j<selected_tournaments.length; j++)
                                        {
                                            //console.log (selected_tournaments);

                                            if (selected_tournaments[j].type == 'turnering')
                                            {
                                                //console.log (selected_tournaments[j].nth_tournament_id);
                                                //console.log (data[i]['id']);
                                                if (selected_tournaments[j].nth_tournament_id == data[i]['id'])
                                                {
                                                    //console.log ('hit');
                                                    item = '<option class="tournament-option" selected value="'+data[i]['id']+'">'+data[i]['name']+' (' + sex + ')</option>';
                                                }
                                                else
                                                {
                                                    //console.log ('miss');
                                                }
                                                
                                            }

                                        }
                                    }

 //                                   if (data[i]['id'] * 1 == window.iTheTournamentID)
 //                                   {
 //                                       item = '<option class="tournament-option" selected value="'+data[i]['id']+'">'+data[i]['name']+'</option>';
  //                                  }
                                    select.append(item);
                                }
                                
                            }
                        }
                    }); 

                    /*$(select).find('option').each ( function ()
                    {
                        if ($(this).val() == data.teamdata.match_selector )
                        {
                            $(this).prop('selected', 'selected');
                            
                        }
                    });*/
                },
                function ()
                {
                    return (false);
                });
            }

        };
        /* eslint-disable */
        acf.addAction('load_field/name=nth_tournament_id', setTournaments);

        acf.addAction('append_field/name=nth_tournament_id', setTournaments);


        /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        TEAM
        - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */

        var setTeams = function( field )
        {
            var select = field.$el.find('select');

            if (select)
            {
                window.iTheTournamentID = 0;

                if (window.getUrlParameter('tag_ID'))
                {
                    window.Ajax.getTaxonomyData (
                    {
                        id: window.getUrlParameter('tag_ID'),
                        tax: window.getUrlParameter('taxonomy'),
                        context: 'admin'
                    },
                    function (data)
                    {
                        window.iTheTournamentID = data.taxonomydata.nth_tournament_id;
                        window.iTheTeamID = data.taxonomydata.nth_team_id;
                        setTeamSelectByTournament ( select, window.iTheTournamentID );
                    },
                    function ()
                    {
                        alert ('Det oppsto en feil');
                        window.iTheTournamentID = 0;
                    });
                }
            }
        };
        /* eslint-disable */
        acf.addAction('load_field/name=nth_team_id', setTeams);

        var setAdsGroups = function( field ) {

            if (field.data.type == 'select')
            {
                $('#acf-field_63493026844e8').find('option:selected').each( function (index)
                {
                    get_tournament_teams_from_prime($(this).attr('value'));
                });
            }

            if (field.data.type == 'checkbox')
            {
                $('.acf-field-66bf216cc1d68').find('input:checked').each( function (index)
                {
                    get_tournament_teams_from_prime($(this).attr('value'));
                });
            }
        };
        
        /* eslint-disable */
        acf.addAction('load_field/name=ad_placement', setAdsGroups);


        $(document).on('click', '[data-name=ad_placement] input[type=checkbox]', function(e)
        {
            get_tournament_teams_from_prime( $(e.target).val() );
        });

        $(document).on('change', '[data-name=ad_placement] select', function(e)
        {
            $('#acf-field_63493026844e8').find('option:selected').each( function (index)
            {
                get_tournament_teams_from_prime($(this).attr('value'));
            });
        }); 
    

        function get_tournament_teams_from_prime(value)
        {
            window.Ajax.getPostData (
            {
                id: acf.get('post_id'),
                context: 'admin'
            },
            function (data)
            {
                window.postFields = data.teamdata;

                var i = 0;

                //console.log ('----');

                //console.log(value);

                //console.log ('----');


                if (value == '')
                {
                    $('[data-name=gl]').find('.acf-checkbox-list').empty();
                    $('[data-name=1d]').find('.acf-checkbox-list').empty();
                }


                if ( (value == 'nth_dist_gl' || value == 'nth_dist_1d') )
                {
                    i ++;
                    if ( value == 'nth_dist_gl')
                    {
                        $.ajax({
                            url: 'https://prime.webcore.no/tournament/' + current_rema_f + '/teams/?usenif&size=20', // acf stored value
                            type: 'get',
                            success: function(data)
                            {
                                if (!data)
                                {
                                    return;
                                }


                                setTeamsByTournament($('[data-name=gl_k').closest('.acf-fields'), '[data-name=gl_k]', data, true);
                            }
                        });

                        $.ajax({
                            url: 'https://prime.webcore.no/tournament/' + current_rema_m + '/teams/?usenif&size=20', // acf stored value
                            type: 'get',
                            success: function(data)
                            {
                                if (!data)
                                {
                                    return;
                                }


                                setTeamsByTournament($('[data-name=gl_m]').closest('.acf-fields'), '[data-name=gl_m]', data, false);
                            }
                        });
                    }

                    if ( value == 'nth_dist_1d')
                    {
                        $.ajax({
                            url: 'https://prime.webcore.no/tournament/' + current_div_f + '/teams/?usenif&size=20', // acf stored value
                            type: 'get',
                            success: function(data)
                            {
                                if (!data)
                                {
                                    return;
                                }


                                setTeamsByTournament($('[data-name=1d_k]').closest('.acf-fields'), '[data-name=1d_k]', data, true);
                            }
                        });

                        $.ajax({
                            url: 'https://prime.webcore.no/tournament/' + current_div_m + '/teams/?usenif&size=20', // acf stored value
                            type: 'get',
                            success: function(data)
                            {
                                if (!data)
                                {
                                    return;
                                }


                                setTeamsByTournament($('[data-name=1d_m]').closest('.acf-fields'), '[data-name=1d_m]', data, false);
                            }
                        });
                    }
                }
               
            },
            function ()
            {
                return (false);
            });

        }


        /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        RELATIONSHIP – REMOVE DEFUNCT POST TYPES
        - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */

        var setRelated = function( field )
        {
            if (field.type === 'relationship') {
                field.data.post_type = ['post', 'sponsor'];
            }

            field.$el.find('select').empty();
            field.$el.find('select').append('<option value="">Velg innholdstype</option>');
            field.$el.find('select').append('<option value="post">Innlegg</option>');
            field.$el.find('select').append('<option value="sponsor">Sponsor</option></select>');
        };
        /* eslint-disable */
        acf.addAction('load_field/name=related', setRelated);
    }

    function setTournamentSelectBySeason (select, season)
    {
        select.empty();
        var temp = '<option>Velg turnering</option>';
        select.append(temp);
        $.ajax({
            url: 'https://prime.webcore.no/tournaments/?usenif&nocache&season=' + season+ '&size=100', // acf stored value
            type: 'get',
            success: function(data)
            {
                if (!data)
                {
                    return;
                }
                for(i=0; i< data.length; i++)
                {
                    var item = '<option class="tournament-option" value="'+data[i]['id']+'">'+data[i]['name']+'</option>';

                    if (data[i]['id'] * 1 == window.iTheTournamentID)
                    {
                        item = '<option class="tournament-option" selected value="'+data[i]['id']+'">'+data[i]['name']+'</option>';
                    }
                    select.append(item);
                }
            }
        });
    }

    function setTeamSelectByTournament (select, tournament)
    {
        select.empty();
        var temp = '<option>Velg lag</option>';
        select.append(temp);
        $.ajax({
            url: 'https://prime.webcore.no/tournaments/' + tournament + '/teams?usenif&nocache&size=100', // acf stored value
            type: 'get',
            success: function(data)
            {
                if (!data)
                {
                    return;
                }
                for(i=0; i< data.length; i++)
                {
                    var item = '<option value="'+data[i]['id']+'">'+data[i]['name']['short']+'</option>';

                    if (data[i]['id'] * 1 == window.iTheTeamID)
                    {
                        item = '<option class="tournament-option" selected value="'+data[i]['id']+'">'+data[i]['name']['short']+'</option>';
                    }

                    select.append(item);
                }
            }
        });
    }


    /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    AD PLACEMENTS
    - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */

    function setTeamsByTournament(parent, selector, data, initial)
    {
        let select = $(parent).find(selector).find('.acf-checkbox-list');

        $(select).html('<li><label class=""><input type="checkbox" class="acf-checkbox-toggle"> Veksle alle</label></li>');

        for(i=0; i < data.length; i++)
        {
            let item = '<li><label><input type="checkbox" id="acf-field_66bcbaa7d3b44-' + data[i]['id'] +'" name="acf[field_66bcbaa7d3b44][]" value="' + data[i]['id'] + '">' + data[i]['name']['short'] + '</label></li>';
            var aTheFieldName = selector.split('=');
            sTheFieldName = aTheFieldName[1].split(']')[0];

            if ($(window.postFields.gl_k).length > 0)
            {
                if ($.inArray( data[i]['id'], window.postFields.gl_k ) >= 0)
                {
                    item = '<li><label><input type="checkbox" id="acf-field_66bcbaa7d3b44-' + data[i]['id'] +'" name="acf[field_66bcbaa7d3b44][]" value="' + data[i]['id'] + '" checked>' + data[i]['name']['short'] + '</label></li>';
                }
            }

             select.append(item);
        }
    }


   

   /* $(document).on('click', '#acf-field_5cf4d1629a2b9 select', function(e)
    {
        $(this).find('option').each( function ()
        {
            if ($(this).val() == 'match' || $(this).val() == 'player' || $(this).val() == 'video' || $(this).val() == 'promotion')
            {
                // //console.log ( $(this).val());
                $(this).remove();
            }
        });
    }); */


    



    function getUrlParameter(sParam)
    {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    }

    window.getUrlParameter = getUrlParameter;


    if ($('.post-type-event').length == 0)
    {
        if ( $('.acf-field-60d35abfb388d').length > 0)
        {
            $('.acf-field-60d35abfb388d').remove();
        }

        if ( $('.acf-field-60d35aebb388f').length > 0)
        {
            $('.acf-field-60d35aebb388f').remove();
        }

        if ( $('.acf-field-60d35ad4b388e').length > 0)
        {
            $('.acf-field-60d35ad4b388e').remove();
        }

        if ( $('.acf-field-60d35affb3890').length > 0)
        {
            $('.acf-field-60d35affb3890').remove();
        }

        if ( $('.acf-field-60d35b0eb3891').length > 0)
        {
            $('.acf-field-60d35b0eb3891').remove();
        }

        if ( $('.acf-field-60d35b34b3892').length > 0)
        {
            $('.acf-field-60d35b34b3892').remove();
        }

        if ( $('.acf-field-60d4342822a8f').length > 0)
        {
            $('.acf-field-60d4342822a8f').remove();
        }

    }


    window.Ajax.generateKaiaArticle = function ( sTheJson, success, failure )
    {
        console.log ('admin_create_kaia_article');
        console.log (window.Ajax);
        console.log (sTheJson);
        window.Ajax.execute ({ class: 'Generate', method: 'admin_create_kaia_article', param: sTheJson }, success, failure );
    }


    window.Ajax.updateKaiaArticle = function ( sTheJson, success, failure )
    {
        //console.log ('admin_update_kaia_article');
        //console.log (window.Ajax);
        //console.log (sTheJson);
        ////console.log (success);
        ////console.log (failure);
        //var type = 'GET';
        window.Ajax.execute ({ class: 'Generate', method: 'admin_get_kaia_update', param: sTheJson }, success, failure );
    }

    window.Ajax.statusKaiaArticle = function ( sTheJson, success, failure )
    {
        //console.log ('admin_get_kaia_status');
        //console.log (sTheJson);
        ////console.log (success);
        ////console.log (failure);
        var type = 'GET';
        window.Ajax.execute ({ class: 'Generate', method: 'admin_get_kaia_status', param: sTheJson }, success, failure );
    }
    
    $(document).on('keydown', '.generate-article', function(e) {
        
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            // Find the next button and focus it
            /*const $nextBtn = $(this).next('button, input[type="button"], input[type="submit"]');
            if ($nextBtn.length) {
                $nextBtn.focus();
            }*/
        }
    });

    $(document).on('click', '.generate-article', function(e)
    {
        e.preventDefault();
        e.stopPropagation();

        
        //alert('Genererer kampartikkel for kamp ID: ' + window.kaia_article_id);

        const $button = $(this);
        const $msg = $('.match-system-message');
        const postID = $button.data('postid');
        const nonce = $button.data('nonce');
    
        $button.prop('disabled', true).addClass('disabled');
        $msg.text('✅ Artikkel opprettes. Dette tar noen minutter. Du kan trygt navigere bort fra denne siden. Du vil finne artikkelen under Innlegg').removeClass('error').removeClass('success');

        alert('Genererer kampartikkel for kamp ID: ' + window.kaia_article_id + ' Team type: ' + window.kaia_article_team);

        window.Ajax.generateKaiaArticle (
        {
            type: $('#match-system-function-select').find('option:selected').val(),
            match_id: window.kaia_article_id,
            team: window.kaia_article_team, 
            context: 'admin'
        },
        function (data)
        {
            /*eslint-disable */
            console.log(data);
            //if (data.response.status == 'success') {
            //    $msg.text('✅ Kampartikkel opprettet. Du finner denne som kladd under innlegg.');

                // Optionally, you can redirect to the new article or refresh the page
                // window.location.href = data.redirect_url; // Uncomment if you want to redirect
            //} else {
            //    $msg.text('❌ Feil ved oppretting av kampartikkel: ' + data.message);
            //} 
        },
        function (error)
        {
            console.error('Error:', error);
            $msg.text('❌ Det oppsto en feil under oppretting av kampartikkel.');
        });
    });

    function checkUpdateStatus(statusDiv) {
        const interval = setInterval(function () 
        {
            window.Ajax.statusKaiaArticle (
            {
                update_id : window.kaiaProgressID,
                context: 'admin'
            },
            function (data)
            {
                
                //console.log (data.response.running);
                if (data.response.running == true)
                {
                    window.kaiaProgressCount ++;
                    percentage = ((window.kaiaProgressCount / 30) * 100).toFixed(2); // Format to 2 decimal places
                    statusDiv.text('Oppdaterer. Ca ' + percentage + '% fullført');
                }
                else if (data.response.running == false)
                {
                    clearInterval(interval);
                    statusDiv.text('Oppdatering fullført');
                    location.reload();
                }
            },
            function (error)
            {
                //console.log (error);
            });  
        }, 5000);  //Check every 5 seconds
    }

});



// WEBPACK FOOTER //
// ./scripts/admin.js